import { useContext } from 'react';
import { FeaturesContext } from '../contexts/FeaturesContext';

/**
 * Custom hook for checking organization feature access
 *
 * This hook consumes the FeaturesContext to access feature data.
 * MUST be used within a FeaturesProvider component.
 *
 * @throws {Error} If used outside of FeaturesProvider
 * @returns {Object} Feature access methods and state
 */
export const useFeatures = () => {
  const context = useContext(FeaturesContext);

  if (context === undefined) {
    throw new Error(
      'useFeatures must be used within a FeaturesProvider. ' +
        'Did you forget to wrap your app with <FeaturesProvider>?',
    );
  }

  return context;
};

export default useFeatures;
